import { Collection } from '@nozbe/watermelondb';

import {
    ProductInvoiceModel,
    ProductInvoicePayload,
} from '../../../../types/Products';
import { DBWriterLoggerFunction } from '../../../../types/logger';

const normalizePrice = (price: string) => price.replace(',', '.');

const prepareUpdateProduct = async ({
    collection,
    id,
    payload,
}: {
    collection: Collection<ProductInvoiceModel>;
    id: string;
    payload: ProductInvoicePayload;
}) => {
    const productPrice = normalizePrice(payload.price);
    const product = await collection.find(id);

    return product.prepareUpdate((p) => {
        p.name = payload.name;
        p.price = productPrice;
        p.available = payload.available;
    });
};

const logUpdateDBActions = ({
    product,
    logDBAction,
    tableName,
}: {
    product: ProductInvoiceModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update invoicing product',
        modelName: tableName,
        payload: product,
    });
};

export { prepareUpdateProduct, logUpdateDBActions };
